import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card3.scss';

class Card3 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Agenda de sustentabilidade avança com pauta ambiciosa - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card3-home page-gradient page-gradient--yellow bg-gray" ref="card3-home">
          <section className="iniciativas-area card3-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Agenda de sustentabilidade avança com pauta ambiciosa</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-10">
                              <p>
                                Em 2020, ampliamos a discussão sobre as práticas ASG (ambientais, sociais e de
                                governança), com a participação de novos membros no Grupo Consultivo de
                                Sustentabilidade. Agora, além das gestoras de recursos, o organismo conta com
                                representantes de emissoras de papéis sustentáveis. O objetivo é promover uma conexão
                                entre o sell side (emissoras) e o buy side (gestoras).
                              </p>
                            </div>
                            <div className="col-2 img-center h-img">
                              <img src={images.iniciativas.card3.img1} className="anima1" />
                            </div>
                          </div>
                          <div className="col-12">
                            <p>
                              O grupo trabalha uma agenda ambiciosa com foco na disseminação do assunto e em iniciativas
                              para incentivo à adoção das práticas ASG. Em janeiro, foi lançado o{' '}
                              <a
                                href="https://www.anbima.com.br/data/files/1A/50/EE/31/BFDEF610CA9C4DF69B2BA2A8/ANBIMA-Guia-ASG-2019.pdf"
                                target="_blank"
                              >
                                Guia ASG – Incorporação dos aspectos ASG nas análises de investimentos
                              </a>
                              , que destaca a importância da adoção desses critérios, traz o panorama atual da
                              utilização no Brasil e no mundo e lista recomendações mínimas que devem ser observadas
                              pelas gestoras na implementação de políticas ASG. Em setembro, publicamos o{' '}
                              <a
                                href="https://www.anbima.com.br/data/files/2B/23/E9/0F/FEF447101699D3471B2BA2A8/Guia de Operacionalizacao do CBIO.pdf"
                                target="_blank"
                              >
                                Guia de Operacionalização do CBIO (Crédito de Descarbonização por Biocombustíveis)
                              </a>
                              , que esclarece as responsabilidades dos prestadores de serviços envolvidos e padroniza as
                              etapas para operacionalização do papel.
                            </p>
                            <p>
                              Em 2020, também começamos uma pesquisa para conhecer o entendimento do mercado de capitais
                              sobre sustentabilidade, além de mensurar a maturidade das instituições com relação ao
                              assunto. O levantamento está em elaboração, com apoio das empresas Na Rua e Datafolha, e
                              deve ser divulgado em julho de 2021.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card3 };
